import { formatDateFromIso } from 'utils';
import VerticalWrapper from './AudienceRowCell.Wrapper';

const AudienceRowCellDateCreated = ({ date }: { date?: string }) => (
  <VerticalWrapper>{date ? formatDateFromIso(date) : null}</VerticalWrapper>
);

export default AudienceRowCellDateCreated;
